export default __webpack_public_path__ + "static/2176-580253fcbce18b5c4ec5381eea9a5b25.gif";